import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  Select,
  Switch,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Structure from '../Structure';
import { Link as Href, useParams } from 'react-router-dom';
import { Link as Enlace } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import data from '../../lib/backend/data';
import toast from 'react-hot-toast';
import { cerrarSesion } from '../../redux/actions/session';
import PropTypes from 'prop-types';
import SinData from '../General/sin_data';
import SecurityIcon from '@mui/icons-material/Security';
import SettingsIcon from '@mui/icons-material/Settings';
import ImageIcon from '@mui/icons-material/Image';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CamposObligatoriosLeyenda from '../../subcomponents/general/formularios/campos_requeridos_leyenda';
import { siEsRequeridoEnEsquema } from '../../lib/helpers/main';

const SeguroDetails = () => {
  const dispatch = useDispatch();
  const [loadingMaster, setLoadingMaster] = useState(true);
  const [loading, setLoading] = useState(false);
  const [seguro, setSeguro] = useState(false);
  const [permisosOtorgados, setPermisosOtorgados] = useState([]);
  const sesion = useSelector((state) => state.miusuario);
  const { id } = useParams();
  const requeridos = [
    { value: 'titulo', label: 'Titulo' },
    { value: 'tipo', label: 'Tipo' },
    { value: 'descripcion', label: 'Descripcion' },
    { value: 'valor', label: 'Valor' },
    { value: 'unidad_medida', label: 'UnidadMedida' },
  ];

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  const obtenerSeguro = async () => {
    return fetch(`${data.urlapi}/seguros?id=${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer: ${sesion.tokenSession}`,
      },
    })
      .then((res) => {
        if (res.status === 401) return dispatch(cerrarSesion());
        return res.json();
      })
      .then((res) => {
        if (!res) {
          toast.error('Sin datos');
          return setLoadingMaster(false);
        } else if (res.errorMessage) {
          toast.error(res.errorMessage);
          return setLoadingMaster(false);
        } else if (res._id) {
          setSeguro(res);
        }
        return setLoadingMaster(false);
      })
      .catch((error) => {
        toast.error('Error al consultar la información, intente nuevamente');
        return setLoadingMaster(false);
      });
  };

  useEffect(() => {
    obtenerSeguro();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    seguro[name] = value;
    console.log(seguro);
    return setSeguro({ ...{}, ...seguro });
  };

  const actualizarSeguro = async () => {
    
    let faltantes = [];
    requeridos.map((campo) => {
      if (!seguro[campo.value]) faltantes.push(campo.label);
      return true;
    });
    if (faltantes.length > 0)
      return toast.error(`Faltan campos: ${faltantes.join(', ')}`);
    seguro.permisos = permisosOtorgados;

    setLoading(true);
    return fetch(`${data.urlapi}/seguros`, {
      method: 'PUT',
      body: JSON.stringify(seguro),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer: ${sesion.tokenSession}`,
      },
    })
      .then((res) => {
        if (res.status === 401) return dispatch(cerrarSesion());
        return res.json();
      })
      .then((res) => {
        if (!res) {
          toast.error('Sin datos');
          return setLoading(false);
        } else if (res.errorMessage) {
          toast.error(res.errorMessage);
          return setLoading(false);
        } else if (res._id) {
          toast.success('Actualizado exitosamente');
        }
        return setLoading(false);
      })
      .catch((error) => {
        toast.error('Error al consultar la información, intente nuevamente');
        return setLoading(false);
      });
  };

  const render = () => {
    if (loadingMaster) return <CircularProgress />;
    if (!seguro) return <SinData />;
    return (
      <div>
        <Breadcrumbs aria-label='breadcrumb'>
          <Href to='/seguro-carga'>Seguros de Carga</Href>
          <Enlace underline='hover' color='text.primary'>
            Editar Seguro
          </Enlace>
        </Breadcrumbs>
        <h1 style={{ margin: 0 }}>Editar Seguro</h1>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item md={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item md={12} xs={12}>
                <Typography variant='h6'>
                  <SettingsIcon sx={{ mb: -0.7 }} /> Detalles</Typography>
                  <CamposObligatoriosLeyenda />
              </Grid>
              <Grid item md={3} xs={12}>
                <TextField
                  label='Título'
                  variant='filled'
                  name='titulo'
                  fullWidth
                  defaultValue={seguro.titulo}
                  required={siEsRequeridoEnEsquema("titulo",requeridos)}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item md={3} xs={12}>
                <FormControl fullWidth className='mb-3'>
                  <InputLabel id='demo-simple-select-label'>Tipo</InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    label='Tipo'
                    name='tipo'
                    required={siEsRequeridoEnEsquema("tipo",requeridos)}
                    onChange={handleChange}
                    defaultValue={seguro.tipo}
                  >
                    <MenuItem value='carga'>Carga</MenuItem>
                    <MenuItem value='cliente'>Cliente</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={3} xs={12}>
                <TextField
                  label='Descripción'
                  variant='filled'
                  name='descripcion'
                  required={siEsRequeridoEnEsquema("descripcion",requeridos)}
                  fullWidth
                  defaultValue={seguro.descripcion}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item md={3} xs={12}>
                <TextField
                  label='Valor'
                  variant='filled'
                  name='valor'
                  required={siEsRequeridoEnEsquema("valor",requeridos)}
                  fullWidth
                  defaultValue={seguro.valor}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item md={3} xs={12}>
                <FormControl fullWidth className='mb-3'>
                  <InputLabel id='demo-simple-select-label'>
                    Unidad Medida
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    label='UnidadMedida'
                    name='unidad_medida'
                    required={siEsRequeridoEnEsquema("unidad_medida",requeridos)}
                    onChange={handleChange}
                    defaultValue={seguro.unidad_medida}
                  >
                    <MenuItem value='uf'>UF</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item md={3} xs={12}>
                <FormControl fullWidth className='mb-3'>
                  <InputLabel id='demo-simple-select-label'>Estado</InputLabel>
                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    label='Estado'
                    name='status'
                    required={siEsRequeridoEnEsquema("status",requeridos)}
                    onChange={handleChange}
                    defaultValue={seguro.status}
                  >
                    <MenuItem value='active'>Activo</MenuItem>
                    <MenuItem value='trash'>Desactivado</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={12} xs={12}>
                {loading === true ? (
                  <CircularProgress />
                ) : (
                  <Button
                    variant='contained'
                    color='success'
                    xs={{ m: 0 }}
                    onClick={() => actualizarSeguro()}
                  >
                    GUARDAR CAMBIOS
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  };

  return <Structure component={render()} />;
};

export default SeguroDetails;
